"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_DISPATCH = exports.ITERABLE_MOVE = exports.ITERABLE_REMOVE = exports.ITERABLE_ADD = exports.ITERABLE_COUNT = exports.TERM_INPUT = exports.UPDATE_TERM_VALUE = exports.UPDATE_TERM_VALUES = exports.REMOVE_FORM = exports.LOAD_FORM = void 0;
exports.LOAD_FORM = "FormModel/LOAD_FORM";
exports.REMOVE_FORM = "FormModel/REMOVE_FORM";
exports.UPDATE_TERM_VALUES = "FormModel/UPDATE_TERM_VALUES";
exports.UPDATE_TERM_VALUE = "FormModel/UPDATE_TERM_VALUE";
exports.TERM_INPUT = "FormModel/TERM_INPUT";
exports.ITERABLE_COUNT = "FormModel/ITERABLE_COUNT";
exports.ITERABLE_ADD = "FormModel/ITERABLE_ADD";
exports.ITERABLE_REMOVE = "FormModel/ITERABLE_REMOVE";
exports.ITERABLE_MOVE = "FormModel/ITERABLE_MOVE";
exports.ACTION_DISPATCH = "FormModel/ACTION_DISPATCH";
//# sourceMappingURL=constants.js.map